<script setup lang="ts">
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import en from 'element-plus/es/locale/lang/en';
import useAppStore from './store/appStore';

const appStore = useAppStore();

const elementLang = computed(() => {
  return appStore.curLang === 'zh' ? zhCn : en;
});
</script>

<template>
  <el-config-provider :locale="elementLang">
    <router-view />
  </el-config-provider>
</template>

<style lang="scss" scoped></style>
